import React from 'react'
import { useDropzone } from 'react-dropzone'
import { Flex, Icon, LinkButton } from '@ui'

interface ISelectFileStepProps {
  onChange: (file: File) => void
  templateApi: () => Promise<string>
  file: File | null
  downloadText: string
  downloadFile: string
  importText: string
}

export default function SelectFileStep({
  onChange,
  templateApi,
  file,
  downloadText,
  downloadFile,
  importText,
}: ISelectFileStepProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files: File[]) => onChange(files[0]),
    accept: {
      'text/csv': ['.csv'],
    },
  })

  const dlTemplate = (blob: string) => {
    const a = document.createElement('a')
    a.download = downloadFile
    a.target = '_blank'
    a.href = window.URL.createObjectURL(new Blob([blob], { type: 'text/plain' }))
    a.click()
  }

  return (
    <div>
      <p>
        <LinkButton
          onClick={() => templateApi().then(dlTemplate)}
          text="Download the .csv template"
        />{' '}
        {downloadText}
      </p>
      <p>{importText}</p>
      <p>New data will be added to existing data.</p>
      <Flex
        align="center"
        justify="center"
        direction="column"
        {...getRootProps()}
        style={{
          height: 200,
          border: `2px dashed ${isDragActive ? 'var(--border-color)' : 'transparent'}`,
          background: '#fafafa',
          borderRadius: 6,
        }}
      >
        <input {...getInputProps()} />
        <Icon
          name="cloud-upload"
          style={{
            fontSize: 34,
            color: isDragActive ? 'var(--primary-color)' : 'var(--grey)',
            marginBottom: 24,
          }}
        />
        <div style={{ textAlign: 'center' }}>
          {file ? `File: ${file.name}` : 'Drag and drop'}
          {file ? (
            <p className="text-xs cursor-default text-grey-500">click to select new file</p>
          ) : (
            <>
              <br /> or <LinkButton text="Browse" />
            </>
          )}
        </div>
      </Flex>
    </div>
  )
}
